import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'

import AdFacebookCreateForm from './AdFacebookCreateForm'
import { AdFacebookCreateContextProvider } from '../../formsContexts/AdFacebookCreateFormContextProvider'

import { lineItemSelector } from '../../../../modules/selectors/lineItems'

import { AD_FACEBOOK_CREATE } from '../../../../constants/forms'
import { CALL_TO_ACTION, CLICK_THROUGH_LINK } from '../fields'

const AdFacebookCreate = ({ campaignObjective = '', lineItemWasLoaded }) => {
  const lineItem = useSelector(lineItemSelector)

  return (
    <FormDrawerWrapper openButtonText="Create Ad" formName={AD_FACEBOOK_CREATE}>
      <AdFacebookCreateContextProvider
        campaignObjective={campaignObjective}
        lineItem={lineItem}
        preselectedValues={{
          ...(lineItem.objective === 'page_likes' &&
            lineItem.promoted_object?.page_id && {
              [CLICK_THROUGH_LINK]: 'https://www.facebook.com/' + lineItem.promoted_object.page_id,
              [CALL_TO_ACTION]: 'LIKE_PAGE'
            })
        }}
      >
        <AdFacebookCreateForm lineItemWasLoaded={lineItemWasLoaded} />
      </AdFacebookCreateContextProvider>
    </FormDrawerWrapper>
  )
}

AdFacebookCreate.propTypes = {
  // some of the props controlled outside of the form
  // it helps to make it more dynamic, like using on rights summary page with multi-form approach
  campaignObjective: PropTypes.string,
  lineItemWasLoaded: PropTypes.bool.isRequired
}

export default AdFacebookCreate
